// Severity of one MediaConnect `Messages[]` entry.
// AWS entries only carry a `Code` ("StreamError", "Warning", ...). Entries the
// reports service appends (Code: REPORTS_SERVICE_ENRICHMENT - e.g. which source
// failed over) state their level in `severity` instead, so reading Code alone
// silently downgrades them to info and drops them from the issue lists.
const CODE_LEVELS = {
  StreamError: 'error',
  Error: 'error',
  Critical: 'error',
  Warning: 'warning',
};

export const messageSeverity = (msg) => {
  // severity/Severity: the payload mixes casing (Code/Message vs severity/incidentId).
  const severity = (msg?.severity ?? msg?.Severity ?? '').toString().trim().toLowerCase();
  if (severity === 'error' || severity === 'critical') return 'error';
  if (severity === 'warning' || severity === 'warn') return 'warning';
  if (severity === 'info') return 'info';
  return CODE_LEVELS[msg?.Code] || 'info';
};

export default messageSeverity;
